import React, { useEffect, useState } from 'react';
import './footer.css';

interface FooterProps {
  lang: string;
}

export const Footer: React.FC<FooterProps> = ({ lang }) => {
  return (
        <footer id="footer" className="site-footer">
			    <hr />
            <div className="container">
                <p>&copy; 2025 LIFTER Studio. All rights reserved.</p>
                <p><a href="#contact">Contact</a></p>
                <img width="128"
                  src="/img/lftr-bn.png" alt="LIFTER Logo"
                />
            </div>
        </footer>
  );
};
